// Reading a case's stored HTML (what the editor saves in cases.content.data).
// Shared by the Cases sidebar card and the Fill Form case picker so a case is
// titled and summarised the same way everywhere.

// The report title is its first <h1>.
export function extractCaseTitle(content: string): string {
  const match = content.match(/<h1[^>]*>(.*?)<\/h1>/);
  return match ? match[1] : "New Note";
}

// The body text without the title or any markup, on one line.
export function stripHtmlTags(html: string): string {
  return html.replace(/<h1.*?<\/h1>/g, "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ");
}

// The editor's placeholders while a report is still being generated.
const PLACEHOLDER = /^(processing audio|drafting report from investigation)/i;

// Is there narrative text a form could be filled from?
export function hasNarrative(content: string | null | undefined): boolean {
  const text = String(content || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  return text.length > 0 && !PLACEHOLDER.test(text);
}
